export default __webpack_public_path__ + "static/media/what-we-do-list-icon.244464b5.svg";